import {useCallback, useState} from "react";
import {useDispatch} from "react-redux";
import {
  activateSim,
  deactivateSim,
  deleteSimData,
  getSimUsageDetails,
  suspendSim,
  updateAddsimModal,
  updateAddsimModalData,
} from "../../../redux/Actions/sims.actions";
import {useFetchSims} from "./useSimTableData";

export const useSimTableActions = (fetchAfterDelete = () => {}) => {
  const [deleteModalStatus, setDeleteModalStatus] = useState(false);
  const [editModalStatus, setEditModalStatus] = useState(false);
  const [selectedSimId, setSelectedSimId] = useState("");
  const [usageModalStatus, setUsageModalStatus] = useState(false);
  const dispatch = useDispatch();
  const {refetch} = useFetchSims();

  const handleDelete = (id) => {
    setDeleteModalStatus(true);
    setSelectedSimId(id);
  };
  const handleEdit = useCallback(
    (data) => {
      dispatch(updateAddsimModalData(data));
      dispatch(updateAddsimModal(true));
      setEditModalStatus(true);
    },
    [dispatch]
  );

  const handleView = useCallback(
    (id) => {
      dispatch(getSimUsageDetails(id));
      setUsageModalStatus(true);
    },
    [dispatch]
  );

  const handleActionSelection = useCallback(
    (action, data) => {
      switch (action) {
        case "View":
          handleView(data.id);
          break;
        case "Edit":
          handleEdit(data);
          break;
        case "Delete":
          handleDelete(data.id);
          break;
      }
    },
    [handleEdit, handleView]
  );

  const selectSimToSuspend = useCallback(
    (sim_id) => {
      dispatch(suspendSim(sim_id, refetch));
    },
    [dispatch, refetch]
  );

  const activateDeactivateSim = useCallback(
    (sim_id, status) => {
      if (status) {
        dispatch(deactivateSim(sim_id, refetch));
      } else {
        dispatch(activateSim(sim_id, refetch));
      }
    },
    [dispatch, refetch]
  );

  const handleToggle = useCallback(
    (data, header) => {
      if (header === "activate") {
        activateDeactivateSim(data.id, data.activate);
      } else {
        selectSimToSuspend(data.id);
      }
    },
    [activateDeactivateSim, selectSimToSuspend]
  );

  const deleteSim = () => {
    const callback = () => {
      setDeleteModalStatus(false);
      setSelectedSimId("");
      fetchAfterDelete();
    };
    dispatch(deleteSimData(selectedSimId, callback));
  };

  return {
    deleteModalStatus,
    deleteSim,
    editModalStatus,
    handleActionSelection,
    handleToggle,
    selectedSimId,
    setDeleteModalStatus,
    setEditModalStatus,
    setUsageModalStatus,
    usageModalStatus,
  };
};
